<script>
    import axios from 'axios'
    import uniq  from "lodash/uniq";
    import RegionItems from './RegionItems.vue'
    import {Listeners} from "../../../constants/listeners";
    import Button from "primevue/button";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";

    export default {
        props: ['model'],
        data () {
            return {
                hasError: false,
                flatRegions: [],
                regionsLabel: null,
                regionTree: [],
                regions: [],
                regionsCopy: [],
                selectedRegions: [],
            }
        },
        methods: {
            close() {
                this.regions = this.regionsCopy;
            },
            apply(){
                var flatRegions = {}, selected = [], self = this;

                this.regions.forEach(function(i){
                    preparedArray(i);
                });

                function preparedArray(item, parent){

                    if(parent){
                        item.parent = parent;
                    }
                    flatRegions[item.id] = item;

                    if(item.isChecked){
                        selected[item.id] = true;
                    }
                    if(item.inner && item.inner.length > 0){
                        item.inners = item.inner.map(function(i){
                            return i.id;
                        });
                        item.inner.forEach(function(i){
                            preparedArray(i, item.id);
                        });
                    }
                }

                this.flatRegions = flatRegions;

                var t;


                t = Object.keys(selected).reduce(function(t, n) {
                    var d;
                    var a;
                    var two;
                    var l = [];
                    var ready = function(t) {
                        t.forEach(function(t) {
                            if(selected[t]){
                                if(flatRegions[t].inners){
                                    ready(flatRegions[t].inners);
                                }
                                delete selected[t];
                            }else{
                                l.push({
                                    id: t,
                                    name: flatRegions[t].name
                                })
                            }
                        })
                    };
                    if(selected[n]){
                        d = self.getFirstCheckedParent(n, selected);
                        a = flatRegions[d];
                        delete selected[d];
                        if(a.inners){
                            ready(a.inners)
                        }
                        two = {
                            id : d,
                            name : a.name,
                            excluded : uniq(l)
                        };
                        t.push(two);
                        return t;
                    }else{
                        return t;
                    }
                }, []);

                if(t.length === 0){
                    this.hasError = true;
                    return false;
                }

                this.regionsLabel = this.stateToText(t);
                this.model.regions = this.stateToValue(t);
                this.$emitter.emit(this.getCloseListener);
            },
            getFirstCheckedParent(e, t){
                let n = e,
                    i = this.flatRegions,
                    o = function(e){
                        t[e] && (n = e),
                        i[e].parent && o(i[e].parent)
                    };
                o(n);
                return n;
            },
            getAllRegionsText(){
                return this.regions.map(e => e.name).join(", ");
            },
            getAllRegionsValue(){
                return this.regions.map(e => e.name).join(",");
            },
            stateToText(states) {
                let self = this;
                let t = states.reduce(function(current, state) {
                    let n = state.name;

                    if(state.excluded.length){
                        (n += "(" + self.$t('lang.report.adcompany.except') + ": " + state.excluded.map(function(e) {
                            return e.name
                        }).join(", ") + ")");
                    }
                    current.push(n);
                    return current;

                }, []);
                return t.join(", ") || this.getAllRegionsText()
            },
            stateToValue(states) {
                let t = states.reduce(function(current, state) {
                    let n = state.name;

                    if(state.excluded.length){
                        (n += state.excluded.map(function(e) {
                            return ",-" + e.name
                        }).join(""));
                    }
                    current.push(n);
                    return current;

                }, []);
                return t.join(",") || this.getAllRegionsValue()
            },
            clear(){
                this.regions = JSON.parse(JSON.stringify(this.regionTree['regions-selector'].regions));
                this.regionsCopy = JSON.parse(JSON.stringify(this.regions));
                this.$emitter.emit(Listeners.REGION_HIDE_ITEM);
            },
            onOpen() {
                this.hasError = false;
                this.regionsCopy = JSON.parse(JSON.stringify(this.regions));
                this.$emitter.emit(Listeners.REGION_SHOW_ITEM);
            }
        },
        computed: {
            getOpenListener() {
                return Listeners.REGION_SHOW_ITEM;
            },
            getCloseListener() {
                return Listeners.REGION_HIDE_ITEM;
            },
            getErrorMessage() {
                return this.hasError ? this.$t('lang.report.adcompany.set_region_err') : null;
            }
        },
        mounted() {
            let self = this;
            axios.get('/resources/' + window.locale + '/regions.json')
                .then(function (response) {
                    self.regionTree = response.data;
                    self.regions = JSON.parse(JSON.stringify(self.regionTree['regions-selector'].regions));
                });
        },
        components: {
            RegionItems,
            Button,
            AdaptersDialog,
        }
    }
</script>
<template>
    <div>
        <Button size="small" :label="$t('lang.main.btn.specify')" @click.prevent="onOpen" severity="secondary" />
        <span v-text="regionsLabel" class="region-info"></span>
        <AdaptersDialog
            :listener-id="getOpenListener"
            :listener-close-id="getCloseListener"
            :header="$t('lang.report.adcompany.view_region')"
            :error-message="getErrorMessage"
            :callback-agree="apply"
            :callback-on-hide="close"
            :button-agree-label="$t('lang.main.btn.apply')"
        >
            <template #content>
                <ul class="tree-container">
                    <region-items v-for="region in regions" :key="region.id" :model="region" class="tree-item"/>
                </ul>
                <Button @click="clear" :label="$t('lang.report.adcompany.clear_region')" text />
            </template>
        </AdaptersDialog>
    </div>

</template>

<style scoped>
    .region-info{display: block; font-size: 14px;}

    .tree-container{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 400px;
        font-size: 13px;
    }
    .tree-container:deep(ul) {
        list-style: none;
        padding-left: 1em;
    }
</style>
